<!-- 动态表单上传 -->
<template>
  <div class="box">
    <div class="title"  v-if="state === '00'">
      <p>{{ title }}：</p>
      <!-- 添加 -->
      <div>
        <el-button :class="[listData.length === 3?'disable':'']" @click="addClick" size="mini" type="primary"
                   icon="el-icon-plus">{{ btnTitle }}
        </el-button>
      </div>
    </div>
    <div class="list_box" v-for="(item,index) in listData" :key="index">
      <p>{{ leftTitle }}{{ index + 1 }}：</p>
      <!-- 上传 -->
      <div v-if="state === '00'">
        <UploadElement v-bind="{existImage: item.url}"
                       :exist-image="item.url"
                       @handleDelete="listData[index].url = ''"
                       @handleChange="v=>listData[index].url = v"/>
      </div>
      <div v-else>
        <el-image
            style="width: 60px; height: 60px;border: 1px dashed #C1CBFF;"
            :src="item.url"
            :preview-src-list="[item.url]">
        </el-image>
      </div>
      <!-- 文本 -->
      <textarea :disabled="state !== '00'" :class="[state === '00'?'':'disable_result']"
                placeholder="请输入判责理由，最多50个字" maxlength="50"
                v-model="listData[index].reason"></textarea>
      <!-- 删除 -->
      <div class="delete" v-if="index" v-show="state === '00'" @click="listData.splice(index,1)">
        <i class="el-icon-remove-outline"/>
      </div>
    </div>
  </div>
</template>
<script>
import UploadElement from "@/components/global/components/elements/upload-element.vue";

export default {
  components: {UploadElement},
  name: "JudgementsList",
  data() {
    return {
      // 内部更改
      listData: [],
      // 避免进入死循环，只有每次列更新才调事件回显
      isWatch: true
    }
  },
  props: {
    // 外部传入初始值
    sourceData: {},
    // 标题
    title: {
      type: String,
      default: "判责依据"
    },
    // 按钮文字
    btnTitle: {
      type: String,
      default: "添加依据"
    },
    // 左方标题
    leftTitle: {
      type: String,
      default: '依据'
    },
    // 最大长度
    maxLength: {
      type: Number,
      default: 3
    },
    //是否重置
    isReset: {
      type: Boolean,
      default: false
    },
    //赋值
    assignmentData: {
      type: Array,
      default: () => []
    },
    // 当前状态
    state:{
      type:String,
      default:'00'
    }
  },
  // dataChange数据变化时，通知父组件的事件
  emits: ['dataChange'],
  watch: {
    // 传递值给父组件
    listData: {
      handler(v) {
        if (this.isWatch) {
          this.$emit('dataChange', v);
        } else {
          // 此时的任何数据更改，除非又是外部传入，反之，统一设置为true
          this.isWatch = true;
        }
      },
      deep: true
    },
    // 清楚值
    isReset(v) {
      if (v) {
        this.listData = [
          {
            url: "",
            reason: "",
            judgeType: ""
          }
        ];
      }
    },
    // 赋值操作
    assignmentData: {
      handler(v) {
        // 外部直接赋值，不能执行listData监听，否则造成死循环
        this.isWatch = false;
        console.log(v)
        if (v.length) {
          this.listData = v;
        } else {
          this.listData = [
            {
              url: "",
              reason: "",
              judgeType: ""
            }
          ]
        }
      },
      deep: true,
    }
  },
  created() {
    this.listData = this.sourceData;
    if (this.sourceData.length) {
      return this.listData = this.sourceData;
    }
    return this.listData = [
      {
        url: "",
        reason: "",
        judgeType: ""
      }
    ]
  },
  methods: {
    addClick() {
      if (this.listData.length === this.maxLength) return;
      this.listData.push({
        url: "",
        reason: "",
        judgeType: ""
      });
    },
  }
}
</script>
<style scoped lang="scss">
.box {
  .title {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
  }

  .list_box {
    padding-left: 15px;
    margin-top: 16px;
    display: flex;
    align-items: center;

    /deep/ .el-upload {
      width: 60px;
      height: 60px;
      border: 1px dashed #C1CBFF;
      transform: translateY(4px);
    }

    > p {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin-right: 17px;
    }

    > textarea {
      width: 500px;
      height: 60px;
      background: #F9FBFD;
      border: 1px solid #C1D1FF;
      border-radius: 4px;
      padding: 12px;
      margin-left: 16px;
      margin-right: 13px;
      box-sizing: border-box;

      &:focus {
        outline: none;
      }
    }

    > .delete {
      cursor: pointer;
      color: #FD677D;
      font-size: 32px;
    }
  }
}

.disable {
  border-color: #bebebe !important;
  background: #bebebe !important;
  cursor: text !important;
}

.disable_result{
  border-color: #eee !important;
  background: #eee !important;
  cursor:no-drop !important;
}
</style>
